import React from "react";
import Page from "../../components/Page";
import ValetsTable from "../../components/ValetsTable";
import InviteUser from "../../components/InviteUser";

export default () => {
  return (
    <Page title={"Valets"}>
      <div className="flex flex-col gap-10">
        <InviteUser />
        <ValetsTable />
      </div>
    </Page>
  );
};
